import { useEffect } from "react";
import Hero from "../components/home/Hero";
import TrustSection from "../components/home/TrustSection";
import AboutSummary from "../components/home/AboutSummary";
import PracticeAreas from "../components/home/PracticeAreas";
import Differentiators from "../components/home/Differentiators";
import FeaturedService from "../components/home/FeaturedService";
import StrongCTA from "../components/home/StrongCTA";
import MissionVisionSummary from "../components/home/MissionVisionSummary";
import ContactSection from "../components/home/ContactSection";

export default function HomePage() {
  useEffect(() => {
    document.title = "Ospino & Piñeres Abogados & Asociados S.A.S. | Asesoría Jurídica y Contable";
  }, []);
  return (
    <>
      <Hero />
      <TrustSection />
      <AboutSummary />
      <PracticeAreas />
      <Differentiators />
      <FeaturedService />
      <StrongCTA />
      <MissionVisionSummary />
      <ContactSection />
    </>
  );
}